import { render, staticRenderFns } from "./createCampaign.vue?vue&type=template&id=65ef530f&scoped=true&lang=pug"
import script from "./createCampaign.vue?vue&type=script&lang=js"
export * from "./createCampaign.vue?vue&type=script&lang=js"
import style0 from "./createCampaign.vue?vue&type=style&index=0&id=65ef530f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef530f",
  null
  
)

export default component.exports